export default (() => navigator.userAgent.includes('Mac'));